import { TrackLinkDirective } from '@analytics/events';
import { NgClass } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';

const isExternalURL = (url: string) => {
  try {
    new URL(url);
    return true;
  } catch (_) {
    return false;
  }
};

@Component({
  selector: 'wl-nav-link',
  standalone: true,
  imports: [NgClass, RouterLink, TrackLinkDirective],
  templateUrl: './nav-link.component.html',
  styleUrls: [
    './nav-link.component.essent.scss',
    './nav-link.component.ed.scss',
  ],
})
export class NavLinkComponent {
  /**
   * Link url provided to this element.
   */
  readonly linkUrl = input.required<string>();
  /**
   * Link title provided to this element.
   */
  readonly linkTitle = input.required<string>();
  /**
   * Theme/style of the element, either dark or light.
   */
  readonly theme = input<'dark' | 'light'>('dark');

  /**
   * State of the element, either active or normal. For instance active would be true is the link is to the home page and the visitor is on the homepage.
   */
  readonly active = input<boolean>(false);

  readonly fullWidth = input(false, {
    transform: (value: boolean | string) =>
      typeof value === 'string' ? value === '' : value,
  });

  clicked = output();

  readonly linkType = computed(() =>
    isExternalURL(this.linkUrl()) ? 'external' : 'internal'
  );

  readonly themeFormatted = computed(
    () => 'navigation-link navigation-link--' + this.theme()
  );
}
